import React from 'react';
import { LazyCartProvider, LazyCartModal } from 'core/utils/lazyCart';
import { getShoppingCartBehavior } from 'core/utils/cart';
import { LazyWrappedCartConfig } from 'component/common/lazyCartActivity';
import { useSelector } from 'react-redux';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';

export const CartRootProvider: React.FC<React.PropsWithChildren<{}>> = React.memo((props) => {
    const config = useSelector(selectConfigFromBootstrap);

    const shoppingCartBehavior = getShoppingCartBehavior(config);
    return (
        <React.Suspense fallback={null}>
            <LazyCartProvider experimental_useZustand={true}>
                {shoppingCartBehavior && (
                    <>
                        <LazyWrappedCartConfig />
                        <LazyCartModal />
                    </>
                )}
                {props.children}
            </LazyCartProvider>
        </React.Suspense>
    );
});
CartRootProvider.displayName = 'CartRootProvider';
